import { useQuery, useMutation } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useGetProfileQuery = (options = {}) => {
  const api = useMatiApiClient('maApi')
  return useQuery({
    queryFn: () => api.profile(),
    queryKey: ['maProfile'],
    ...options
  })
}

export const useUpdateProfilePreferences = (options = {}) => {
  const api = useMatiApiClient('maApi')
  return useMutation({
    optimisticUpdateKey: ['maProfile'],
    optimisticUpdateFn: (curr, next) => {
      return {
        ...curr,
        preferences: {
          ...curr?.preferences,
          ...next
        }
      }
    },
    mutationFn: (preferences) => api.updateProfilePreferences({ preferences }),
    ...options,
  })
}
